import React, { Component } from "react";
import { connect } from "react-redux";
import disableBrowserBackButton from "disable-browser-back-navigation";

import MetalItem from "./metals/Item";
import CurrencyItem from "./currencies/Item";
import { pageActions } from "../actions";
import CONFIG from "../config";
import { BackToStartButton, KonditionenSwitch } from ".";
import { scrollToTop } from "../utils/functions";
import { ReactPaginateWCAG } from "../utils/components";
import ServiceContactInfo from "./ServiceContactInfo";

//sort by field and if fields value is same then sort by name
const sortList = (field, reverse) => {
  const key = (item) => { return item[field]; };
  const keyName = y => { return y.name; };
  reverse = !reverse ? 1 : -1;
  return (a, b) => {
    //if fields have same value then compare by name
    if (key(a) === key(b)) {
      return reverse * ((keyName(a) > keyName(b) ? 1 : 0) + (keyName(b) > keyName(a) ? -1 : 0));
    } else {
      return reverse * ((key(a) > key(b) ? 1 : 0) + (key(b) > key(a) ? -1 : 0));
    }
  };
};

class List extends Component {
  constructor(pros) {
    super(pros);
    this.state = {
      detailItem: {}
    };
    this.handlePageClick = this.handlePageClick.bind(this);
    this.hrefBuilder = this.hrefBuilder.bind(this);
    this.ariaLabelBuilder = this.ariaLabelBuilder.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let storage = CONFIG.getShopConfig({
      edelmetall: props.metalsStorage,
      sorten: props.currenciesStorage
    });
    if (!props.panelStorage || !storage) return { ...state, items: [] };
    let items;
    if (props.panelStorage.isQueryActive()) {
      items = storage.getQueryItems(props.panelStorage.getQuery());
    } else {
      items = storage.getItems();
    }
    if (props.panelStorage.isFiltered()) {
      const kind = props.panelStorage.getKind();
      const make = props.panelStorage.getMake();
      items = items.filter(item => {
        return (!kind || item.kind === kind) && (!make || item.make === make);
      });
    }
    const orderSplit = String(props.panelStorage.getOrder()).split("-");
    items.sort(sortList(orderSplit[0], orderSplit[1] !== "asc"));
    return { ...state, items };
  }

  componentDidMount = async () => {
    disableBrowserBackButton();
  };

  getItemsPaginationMaxPages() {
    return Math.ceil(
      this.state.items.length / this.props.panelStorage.getPageSize()
    );
  }

  hrefBuilder() {
    return "#";
  }
  
  ariaLabelBuilder(pageIndex, selectedPage) {
    if (pageIndex === selectedPage) {
      return "Ausgewählte Seite " + pageIndex;
    } else {
      return "Zur Seite " + pageIndex;
    }
  }

  handlePageClick(data) {
    scrollToTop();
    this.props.dispatch(pageActions.setPageNumber(data.selected));
  }

  renderItems() {
    if (!this.state.items.length) return;
    let Item = CONFIG.getShopConfig({
      edelmetall: MetalItem,
      sorten: CurrencyItem
    });
    return this.state.items.slice(this.getMinPagination(), this.getMaxPagination()).map((item) =>
      <Item
        key={item.kennziffer}
        item={item}
        handleOpenDetails={this.handleOpenDetails}
      />
    );
  }

  getMinPagination() {
    return this.props.pageStorage.getPageNumber() * this.props.panelStorage.getPageSize();
  }

  getMaxPagination() {
    return Math.min(this.getMinPagination() + this.props.panelStorage.getPageSize(), this.state.items.length);
  }

  isFilteredItemsEmpty() {
    return this.props.panelStorage.isFiltered() && this.state.items.length === 0;
  }

  isQueryItemsEmpty() {
    return this.props.panelStorage.isQueryActive() && this.state.items.length === 0;
  }

  render() {
    let errorMessage;
    if (this.isQueryItemsEmpty()) {
      errorMessage =
        "Leider konnten für diese Suche keine Treffer gefunden werden.";
    } else if (this.isFilteredItemsEmpty()) {
      errorMessage = "Der aktuelle Filter hat leider keine Treffer.";
    }

    return (
      <div>
        {!!errorMessage ? (
          <div className={"ser-noitems"}>{errorMessage}</div>
        ) : (
          <div>
            <div className="ser-pagination-box mb-one">
              {this.getItemsPaginationMaxPages() > 1
                ? <>
                  <ReactPaginateWCAG
                    ariaTitle="Seitennavigation oben"
                    previousLabel={"<"}
                    nextLabel={">"}
                    breakLabel={<span className="ser-dots">...</span>}
                    breakClassName={"ser-iblock ser-page"}
                    pageCount={this.getItemsPaginationMaxPages()}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={2}
                    forcePage={this.props.pageStorage.getPageNumber()}
                    onPageChange={this.handlePageClick}
                    containerClassName={"ser-pagination mb-0"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    previousClassName={"ser-iblock ser-page"}
                    nextClassName={"ser-iblock ser-page"}
                    pageClassName={"ser-iblock ser-page"}
                    disabledClassName={"ser-iblock ser-page disabled"}
                    hrefBuilder={this.hrefBuilder}
                    hrefAllControls={true}
                    breakAriaLabels={{ forward: "Nächste Seite", backward: "Vorherige Seite" }}
                    ariaLabelBuilder={this.ariaLabelBuilder}
                  />
                  <div className="ser-pagerange ser-iblock d-flex align-items-center">
                    Treffer {this.getMinPagination() + 1} -{" "}
                    {this.getMaxPagination()} von {this.state.items.length}{" "}
                  </div>
                </>
                : null
              }
              <div className="d-flex align-items-center gap-1">
                <BackToStartButton className="btn-sm" />
                <KonditionenSwitch />
              </div>
            </div>
            <section aria-label="Liste der Produkte">
              <ul className="ser-items ser-pagesize-0" >
                {this.renderItems()}
              </ul>
            </section>
            <div className="ser-pagination-box">
              {this.getItemsPaginationMaxPages() > 1
                ? <>
                  <ReactPaginateWCAG
                    ariaTitle="Seitennavigation unten"
                    previousLabel={"<"}
                    nextLabel={">"}
                    breakLabel={<span className="ser-dots">...</span>}
                    breakClassName={"ser-iblock ser-page"}
                    pageCount={this.getItemsPaginationMaxPages()}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={2}
                    forcePage={this.props.pageStorage.getPageNumber()}
                    onPageChange={this.handlePageClick}
                    containerClassName={"ser-pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    previousClassName={"ser-iblock ser-page"}
                    nextClassName={"ser-iblock ser-page"}
                    pageClassName={"ser-iblock ser-page"}
                    disabledClassName={"ser-iblock ser-page disabled"}
                  />
                  <div className="ser-pagerange ser-iblock">
                    Treffer {this.getMinPagination() + 1} -{" "}
                    {this.getMaxPagination()} von {this.state.items.length}
                  </div>
                </>
                : null
              }
              <BackToStartButton className="btn-sm" />              
            </div>
            <ServiceContactInfo/>
          </div>
        )}
      </div>
    );
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    metalsStorage: store.metalsStorage,
    currenciesStorage: store.currenciesStorage,
    panelStorage: store.panelStorage,
    pageStorage: store.pageStorage
  };
})(List);
